"use client"

import { IceCreamCone } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `IceCreamConeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const IceCreamConeIcon = component(Icon)({ as: IceCreamCone })
